import { render, staticRenderFns } from "./NewPurchasePage.vue?vue&type=template&id=aaa6f6c2&scoped=true&"
import script from "./NewPurchasePage.vue?vue&type=script&lang=ts&"
export * from "./NewPurchasePage.vue?vue&type=script&lang=ts&"
import style0 from "./NewPurchasePage.vue?vue&type=style&index=0&id=aaa6f6c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa6f6c2",
  null
  
)

export default component.exports